<template>
    <div class="countryList" id="countryList">
        <div class="search" id="search">
            <div class="inputItem">
                <img src="@/assets/images/login/a_login_search.png"/>
                <input :placeholder="$t('login.countrySearch')" v-model="keyword">
            </div>
            <span @click="back">{{$t('message.cancel')}}</span>
        </div>
        <div class="layout" id="layout">
            <div class="curCountry" id="curCountry">
                <p>{{$t('login.curCountry')}}</p>
                <div class="item" @click="checkCountryCode('84')"><span>Vietnam</span><span>+84</span></div>
            </div>
            <div class="countryCon">
                <p id="current">{{$t('login.countrySelect')}}</p>
                <ul>
                    <li v-for="item in country" @click="checkCountryCode(item.countryCode)"><span>{{item.name}}</span><span>+{{item.countryCode}}</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/plugins/api'
    export default {
        name: "Country",
        data() {
            return {
                countryData: "",
                keyword: "",
                sourceType:this.$route.query.type||"",
            }
        },
        computed: {  //设置计算属性
            country: {
                get() {
                    if (this.keyword) {
                        return this.countryData.filter((value) => {
                            if (!isNaN(this.keyword)) return String(value.countryCode).indexOf(this.keyword) > -1;
                            else return String(value.name).indexOf(this.keyword) > -1;
                        });
                    } else return this.countryData
                }
            }
        },
        methods: {
            back(){
                this.$router.go(-1)
            },
            countryList() {
                api.getCountryList().then(res => {
                    if (res.status == 200) {
                        this.countryData = res.data;
                    }
                })
            },
            checkCountryCode(code) {
                if (this.sourceType == "login") this.$router.push({path: '/login', query: {countryCode: code}})
                else if (this.sourceType == "registered") this.$router.push({path: '/registered', query: {countryCode: code}})
            },
        },
        mounted() {
            this.countryList();
            let curCountryH = document.getElementById("curCountry").offsetHeight;
            let current = document.getElementById("current");
            window.onscroll = function () {
                let scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                if (scroll >= curCountryH) {
                    current.classList.add("fixed")
                } else {
                    current.classList.remove("fixed")
                }
            };
        },
    }
</script>
